import moment from 'moment';
import { message } from 'antd';
import {
  getPage,
  getPageExpert,
  getStandardPage,
  getStandardPageExpert,
  standardAdd,
  standardEdit,
  standardDel,
  preCreateCheck,
  standardImport,
  detailedEdit,
  getDetailedPage,
  getDetailedPageExpert,
  refresh,
  actualAging,
} from '@/services/countytimeeffect';

export default {
  namespace: 'countydistance',
  state: {
    activeKey: 'query',
    selectedRowKeys: [],
    // standard
    standardSearch: { agingType: '' },
    standardTable: [],
    standardPage: 1,
    standardPageSize: 50,
    standardTotal: 0,
    // detailed
    detailedSearch: { agingType: '' },
    detailedTable: [],
    detailedPage: 1,
    detailedPageSize: 50,
    detailedTotal: 0,
    // query
    querySearch: { timeeffect: 'allAging' },
    queryTable: [],
    queryPage: 1,
    queryPageSize: 50,
    queryTotal: 0,

    editVisiable: false,
    insertData: {}, // 新增值
    drawerType: 'add', // 弹窗状态

    importVisible: false,
    importErrMsg: {},
    exportVisible: false,
  },

  effects: {
    /**
     * 时效距离  查询
     */
    *getquery({ payload }, { call, put, select }) {
      const countydistance = yield select(({ countydistance }) => countydistance);
      const { querySearch, queryPage, queryPageSize } = countydistance;
      const {
        fromCountyName,
        fromSiteName,
        fromProvinceAreaName,
        toCountyName,
        toSiteName,
        toProvinceAreaName,
        timeeffect,
        txt,
      } = querySearch;
      let params = { page: queryPage, pageSize: queryPageSize };
      if (!!fromCountyName) {
        if (fromCountyName.length === 3) {
          params.fromCountyCode = fromCountyName[2].value;
        }
      }
      if (!!toCountyName) {
        if (toCountyName.length === 3) {
          params.toCountyCode = toCountyName[2].value;
        }
      }

      if (txt) {
        params[timeeffect] = txt;
      }
      // 导出
      if (payload?.isExport === 1) {
        params = { ...params, ...payload };
        const expertResult = yield call(getPageExpert, {
          fromSiteCode: fromSiteName?.code,
          fromProvinceAreaCode: fromProvinceAreaName?.code,
          toSiteCode: toSiteName?.code,
          toProvinceAreaCode: toProvinceAreaName?.code,
          ...params,
        });
        if (expertResult && expertResult.code === 1) {
          const res = {
            exportVisible: false,
          };
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: res,
          });
        }
      } else {
        const result = yield call(getPage, {
          fromSiteCode: fromSiteName?.code,
          fromProvinceAreaCode: fromProvinceAreaName?.code,
          toSiteCode: toSiteName?.code,
          toProvinceAreaCode: toProvinceAreaName?.code,
          ...params,
        });
        if (result && result.code === 1) {
          let res = { queryTable: result.data?.rows || [], queryTotal: result?.data?.total || 0 };
          yield put({
            type: 'updateState',
            payload: res,
          });
        }
      }

    },
    /**
     * 时效距离标准  查询 导出
     */
    *getstandard({ payload }, { call, put, select }) {
      const { standardSearch, standardPage, standardPageSize } = yield select(
        ({ countydistance }) => countydistance,
      );
      const { agingType } = standardSearch;
      let params = { page: standardPage, pageSize: standardPageSize, agingType };
      // 导出
      if (payload?.isExport === 1) {
        params = { ...params, ...payload };

        const expertResult = yield call(getStandardPageExpert, params);
        if (expertResult && expertResult.code === 1) {
          let res = {
            exportVisible: false,
          };
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: res,
          });
        }
      } else {
        const result = yield call(getStandardPage, params);
        if (result && result.code === 1) {
          let res = {
            standardTable: result.data?.rows || [],
            standardTotal: result?.data?.total || 0,
          };
          yield put({
            type: 'updateState',
            payload: res,
          });
        }
      }

    },
    /**
     * 新增,编辑  时效距离标准
     */
    *standardAdd({ payload }, { call, put, select }) {
      const { drawerType } = yield select(({ countydistance }) => countydistance);
      const { insertData } = payload;
      const { distanceLimit, agingType, agingDefine, id } = insertData;
      if (distanceLimit[0] >= distanceLimit[1]) {
        return message.warning('距离2必须大于距离1');
      }
      let params = {
        distanceLimitLower: distanceLimit[0] * 1000,
        distanceLimitUpper: distanceLimit[1] * 1000,
        agingType,
        agingDefine,
        id,
      };
      let req = standardAdd;
      if (drawerType === 'edit') {
        req = standardEdit;
      }
      const result = yield call(req, params);
      if (result && result.code === 1) {
        yield put({
          type: 'updateState',
          payload: {
            insertData: {},
            editVisiable: false,
          },
        });
        yield put({
          type: 'getstandard',
        });
      }
    },
    /**
     * 删除  时效距离标准
     */
    *standardDel({ payload }, { call, put }) {
      const result = yield call(standardDel, payload);
      if (result && result.code === 1) {
        if (result?.message) message.success(result?.message);
        yield put({
          type: 'getstandard',
        });
      }
    },
    /**
     * 导入校验  时效距离标准
     */
    *preCreateCheck({ payload: { data, setCurrent } }, { call, put }) {
      const result = yield call(preCreateCheck, data);
      if (result && result.code === 1) {
        if (!!result?.data && result?.data.length > 0) {
          yield put({
            type: 'updateState',
            payload: { importErrMsg: result?.data },
          });

          setCurrent(1);
        } else {
          const res = yield call(standardImport, data);
          if (res && res.code === 1) {
            setCurrent(2);
          }
        }
      }
    },
    /**
     * 同步  时效距离标准
     */
    *refresh({ payload }, { call, put }) {
      const result = yield call(refresh, payload.ids);
      if (result && result.code === 1) {
        if (result?.message === '时效距离明细全量刷新失败') {
          message.error(result?.message);
        } else {
          message.success(result?.message);
        }
        yield put({
          type: 'updateState',
          payload: { selectedRowKeys: [] },
        });
      }
    },

    /**
     * 时效距离明细  查询 导出
     */
    *getdetailed({ payload }, { call, put, select }) {
      const { detailedSearch, detailedPage, detailedPageSize } = yield select(
        ({ countydistance }) => countydistance,
      );
      const {
        arrivalCounty,
        arrivalSite,
        departureCounty,
        departureSite,
        createTimeStart,
        createTimeEnd,
        updateTimeStart,
        updateTimeEnd,
        ...others
      } = detailedSearch;
      let departure;
      let arrival;
      if (departureCounty && departureCounty.length === 3) {
        departure = `${departureCounty[0].label}/${departureCounty[1].label}/${departureCounty[2].label}`;
      }
      if (departureSite) {
        departure = departureSite?.name;
      }
      if (arrivalCounty && arrivalCounty.length === 3) {
        arrival = `${arrivalCounty[0].label}/${arrivalCounty[1].label}/${arrivalCounty[2].label}`;
      }
      if (arrivalSite) {
        arrival = arrivalSite?.name;
      }
      let params = {
        page: detailedPage,
        pageSize: detailedPageSize,
        arrival,
        departure,
        createTimeStart: handlerTime(createTimeStart, 'YYYY-MM-DD 00:00:00'),
        createTimeEnd: handlerTime(createTimeEnd, 'YYYY-MM-DD 23:59:59'),
        updateTimeStart: handlerTime(updateTimeStart, 'YYYY-MM-DD 00:00:00'),
        updateTimeEnd: handlerTime(updateTimeEnd, 'YYYY-MM-DD 23:59:59'),
        ...others,
      };
      // 导出
      if (payload?.isExport === 1) {
        params = { ...params, ...payload };
        if (payload?.isExport === 1) {
          const expertResult = yield call(getDetailedPageExpert, params);
          if (expertResult && expertResult.code === 1) {
            let res = {
              exportVisible: false,
            };
            message.success('导出成功');
            yield put({
              type: 'updateState',
              payload: res,
            });
          }
        }

  
      } else {
        const result = yield call(getDetailedPage, params);
        if (result && result.code === 1) {
          let res = {
            detailedTable: result.data?.rows || [],
            detailedTotal: result?.data?.total || 0,
          };
          yield put({
            type: 'updateState',
            payload: res,
          });
        }
      }

    },
    /**
     * 时效距离明细   编辑
     */
    *detailedEdit({ payload }, { call, put }) {
      const { insertData } = payload;
      const result = yield call(detailedEdit, insertData);
      if (result && result.code === 1) {
        yield put({
          type: 'updateState',
          payload: {
            insertData: {},
            editVisiable: false,
          },
        });
        yield put({
          type: 'getdetailed',
        });
      }
    },
    /**
     * 时效距离明细   计算时效
     */
    *actualAging({ payload }, { call }) {
      const { insertData, callback } = payload;
      const result = yield call(actualAging, insertData);
      if (result && result.code === 1) {
        callback && callback(result);
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
    updateDetailedSearchParams(state, { payload }) {
      return { ...state, detailedSearch: { ...state.detailedSearch, ...payload } };
    },

    
  },
};

const handlerTime = (time, format) => {
  if (!!time) {
    if (format) {
      return moment(time).format(format);
    } else {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    }
  } else {
    return time;
  }
};
